<template>
<div>
  <div class="container" :style="{ 'background-color': hex.value }">
    <h1 :style="{ 'color': textColor }">
      <span>{{ hex.value }}</span>
      <span>{{ rgbCSS(rgb) }}</span>
      <span>{{ hslCSS(hsl) }}</span>
    </h1>
    
    <div id="color-picker">
      <form>
        <div class="color-sliders">
          <div class="sliders">
            <div class="hue">
              <input type="range"
                min="0" max="360"
                class="slider"
                id="hueRange"
                v-model="hsl.hue"
                @input="hslChanged">
              <div class="range-thumb" :style="'left: ' + (hsl.hue / 360) * 100 + '%;'"></div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
class Color {
  constructor (oneColor) {
    this.oneColor = oneColor
  }

  hsl () {
    return {
      hue: Math.round(this.oneColor.hue() * 360),
      saturation: Math.round(this.oneColor.saturation() * 100),
      lightness: Math.round(this.oneColor.lightness() * 100),
    }
  }

  rgb () {
    return {
      red: Math.round(this.oneColor.red() * 255),
      green: Math.round(this.oneColor.green() * 255),
      blue: Math.round(this.oneColor.blue() * 255),
    }
  }

  hsv () {
    return {
      hue: Math.round(this.oneColor.hue() * 360),
      saturation: Math.round(this.oneColor.saturation() * 100),
      value: Math.round(this.oneColor.value() * 100),
    }
  }

  hex () {
    return {
      value: this.oneColor.hex(),
    }
  }
 
  static fromRGB (rgb) {
    return new Color(this.oneColor(rgbCSS(rgb)))
  }

  static fromHSL (hsl) {
    return new Color(this.oneColor(hslCSS(hsl)))
  }

  static fromHex (hex) {
    return new Color(this.oneColor(hex.value))
  }
}

function backgroundCSS (rgbColor) {
  return 'background-color: '+ rgbCSS(rgbColor)
}

function hslCSS (color) {
  return 'hsl(' + color.hue + ', ' + color.saturation + '%, ' + color.lightness + '%)'
}

function rgbCSS (color) {
  return 'rgb(' + color.red + ', ' + color.green + ', ' + color.blue + ')'
}
// import { Color, backgroundCSS, hslCSS, rgbCSS } from '@/utils/Color'
// import { Color, backgroundCSS } from '@/utils/Color'

export default {
  name: 'tooltip-icon',
  props: {
    content: {
      type: String,
      default: 'info'
    },
    size: {
      type: String,
      default: 'md'
    },
  },
  data () {
    return {
      hsl: {
        hue: 180,
        saturation: 80,
        lightness: 50,
      },
    }
  },
  computed: {
    newColorStyle: function () {
      return backgroundCSS(this.rgb)
    },
    textColor: function () {
      if (this.hsl.lightness > 74) {
        return '#444'
      } else {
        return '#fff'
      }
    }
  },
  created () {
    this.reset()
  },
  methods: {
    setAll (color) {
      const types = ['hsl', 'hsv', 'rgb', 'hex']
      for (const i in types) {
        this[types[i]] = color[types[i]]()
      }
    },
    
    reset () {
      const updatedColor = Color.fromHSL(this.hsl)
      this.setAll(updatedColor)
    },
    
    hslChanged () {
      // const color = Color.fromHSL(this.hsl)
      this.reset()
    },
    
    lightnessBackgroundStyle () {
      return 'background: linear-gradient(to right, #000000 0%, ' + this.getHueOutput() + ' 50%, #ffffff 100%)'
    },
    
    saturationBackgroundStyle () {
      return 'background: linear-gradient(to right, ' + this.getDesaturatedOutput() + ' 0%, ' + this.getHueOutput() + ' 100%)'
    },
    
    getHueOutput () {
      return this.oneColor('hsl(' + this.hsl.hue + ', 100%, 50%)').hex()
    },
    
    getDesaturatedOutput () {
      return this.oneColor('hsl(' + this.hsl.hue + ', 0%, 50%)').hex()
    }
  }
}
</script>
